// export const v8 = "https://d5dn8hh4ivlobv6682ep.apigw.yandexcloud.net";
export const v8 = "https://cloud.js-dos.com";
